import { render, staticRenderFns } from "./overview-header-email.vue?vue&type=template&id=466fb4aa&"
import script from "./overview-header-email.vue?vue&type=script&lang=js&"
export * from "./overview-header-email.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports